module.exports = __webpack_public_path__ + "img/herren40_3.ba83e825.jpeg";